import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

export const initSliders = (selector) => {
    const sliders = document.querySelectorAll(selector);
    if (!sliders.length) return;

    sliders.forEach(item => {
        if (item.swiper) return;

        const parent        = item.closest('.slider-content');
        const navButtons    = parent.dataset.navButtons === "true";
        const pagination    = parent.dataset.pagination === "true";
        const autoplay      = parent.dataset.autoplay === "true";
        const speed         = parseInt(parent.dataset.speed) || 5000;
        const speedChanges  = parseInt(parent.dataset.speedChanges) || 600;
        const loop          = parent.dataset.loop === "true";
        const viewDesktop   = parseFloat(parent.dataset.viewDesktop) || 4;
        const viewTablet    = parseFloat(parent.dataset.viewTablet) || 2;
        const viewMobile    = parseFloat(parent.dataset.viewMobile) || 1;
        const totalSlides   = item.querySelectorAll('.swiper-slide').length;
        const enoughForLoop = totalSlides > viewDesktop;
        const center        = parent.dataset.center === "true";

        const swiper = new Swiper(item, {
            slidesPerView: viewMobile,
            spaceBetween: 18,
            navigation: navButtons ? {
                nextEl: parent.querySelector(".swiper-button-next"),
                prevEl: parent.querySelector(".swiper-button-prev"),
            } : false,
            pagination: pagination ? {
                el: parent.querySelector(".swiper-pagination"),
                clickable: true,
            } : false,
            autoplay: autoplay ? {
                delay: speed,
                disableOnInteraction: false,
            } : false,
            speed: speedChanges,
            loop: loop && enoughForLoop,
            centeredSlides: center,
            breakpoints: {
                640: { slidesPerView: viewMobile, spaceBetween: 12, centeredSlides: center },
                768: { slidesPerView: viewTablet, spaceBetween: 12, centeredSlides: false },
                1200: { slidesPerView: viewDesktop, centeredSlides: false },
            },
        });

        document.addEventListener('swiperNeedUpdate', () => {
            swiper.update();
        });
    });
};